<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>汽车列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
      <el-form
        :inline="true"
        :model="searchForm"
        :rules="searchRules"
        ref="searchForRef"
        label-width="80px"
        autocomplete="on"
        size="mini"
      >
      <el-row :gutter="24">
        <el-col :span="24">

            <el-form-item label="标题">
              <el-input v-model="searchForm.title" clearable type="text"></el-input>
            </el-form-item>
            <el-form-item label="车系">
                <el-cascader v-model="searchForm.style_ids"
                             style="width: 100%" ref="cascaderCarStyle" @change="getval($event)"
                             :props="{ value: 'id',label: 'name',children: 'children',checkStrictly: true}" :options="carStyleMenus" clearable></el-cascader>
            </el-form-item>
            <el-form-item label="年份">
                <el-select
                        v-model="searchForm.year_id"
                        filterable
                        clearable
                        default-first-option
                        placeholder="请选择年份">
                    <el-option
                            v-for="item in carYearList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>

          <el-form-item>
            <el-button type="success"  @click="searchSubmit()">搜索</el-button>
              <el-button type="primary" @click="goAdd()">
                  <i class="el-icon-plus" ></i>新增
              </el-button>
          </el-form-item>
        </el-col>

      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item>

          </el-form-item>
        </el-col>
      </el-row>
      </el-form>
      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        :data="tableLoadData"
        stripe
        border
        size="mini"
      >
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column :index="indexMethod" type="index" label="序号" width="50"></el-table-column>

        <el-table-column
          label="标题"
          width="120"
          prop="title"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          label="车系"
          width="200"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            {{scope.row.style&&scope.row.style.parent?scope.row.style.parent.name:''}}
            {{scope.row.style?scope.row.style.name:''}}
          </template>
        </el-table-column>
          <el-table-column
                  label="年份"
                  width="160"
          >
              <template slot-scope="scope">
                  {{scope.row.year?scope.row.year.name:''}}
              </template>
          </el-table-column>
        <el-table-column
          label="孔距"
          width="100"
        >
          <template slot-scope="scope">
            {{scope.row.pitch?scope.row.pitch.name:''}}
          </template>
        </el-table-column>
          <el-table-column
                  width="80"
                  label="是否检测"
          >
              <template slot-scope="scope">
                  {{scope.row.detections?'是':''}}
              </template>
          </el-table-column>
          <el-table-column
                  width="80"
                  label="推荐"
          >
              <template slot-scope="scope">
                  {{scope.row.is_recommend==1?'是':""}}
              </template>
          </el-table-column>
          <el-table-column
                  width="80"
                  label="排序"
          >
              <template slot-scope="scope">
                  {{scope.row.sort}}
              </template>
          </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="180">
          <template slot-scope="scope">
              <el-button v-if="scope.row.file_url" @click="detectWheels(scope.row)"  type="text" size="mini">检测轮毂</el-button>
            <el-button @click="goEdit(scope.row)"  type="text" size="mini">编辑</el-button>
            <el-button @click="relationHub(scope.row)"  type="text" size="mini">关联轮毂</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->

    <el-drawer
            title="轮毂列表"
            :visible.sync="drawerHub"
            :with-header="false">
      <el-table
              style="margin-top: 20px;"
              ref="multipleTable"
              :data="hubList"
              size="mini"
              stripe
              border
      >
<!--        <el-table-column label="" width="50" align="center">-->
<!--          <template slot-scope="scope">-->
<!--            <el-radio v-model="curHub" :label="scope.row" @input="clickChange(scope.row,scope.$index)">{{ "" }}</el-radio>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column  type="index" label="序号" width="50"></el-table-column>
        <el-table-column
                label="图片"
                width="150"
                :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <el-image
                    style="width: 50px; height: 50px"
                    :src="scope.row.goods_img"

                    :preview-src-list="[scope.row.goods_img]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
                label="名称"
                width="150"
                :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.goods_name}}</span>
          </template>
        </el-table-column>
        <el-table-column
                label="孔距"
                width="80"
                :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.pitch?scope.row.pitch.name:''}}</span>
          </template>
        </el-table-column>
        <el-table-column
                label="市场价"
                width="80"
                :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.market_price}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="block" style="margin-top:10px">
        <el-pagination
                background
                @size-change="handleSizeChange1"
                @current-change="handleCurrentChange1"
                :current-page="pageNum1"
                :page-sizes="[10, 20, 30, 100]"
                :page-size="pageSize1"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total1">
        </el-pagination>
      </div>
    </el-drawer>


      <el-dialog
              :visible.sync="processing"
              :show-close="false"
              :close-on-click-modal="false"
              :close-on-press-escape="false"
              width="30%"
      >
          <div class="loading-dialog">
              <el-progress
                      type="circle"
                      :percentage="progress"
                      :status="progress === 100 ? 'success' : undefined"
              />
              <div class="loading-text">
                  <p>{{ loadingText }}</p>
                  <p v-if="progress > 0">{{ progress }}%</p>
              </div>
          </div>
      </el-dialog>
  </div>
</template>

<script>
    import axios from 'axios'
    // API配置
    const API_BASE_URL = 'https://jm.shuangma88.com'; // 根据实际情况修改

    // 创建axios实例
    const http = axios.create({
        baseURL: API_BASE_URL,
        timeout: 30000,
        headers: {
            'Content-Type': 'application/json'
        }
    });

    // 请求拦截器
    http.interceptors.request.use(
        (config) => {
            // 可以在这里添加token等认证信息
            // const token = localStorage.getItem('token');
            // if (token) {
            //   config.headers.Authorization = `Bearer ${token}`;
            // }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    // 响应拦截器
    http.interceptors.response.use(
        (response) => {
            return response.data;
        },
        (error) => {
            const errorMsg = error.response?.data?.error || error.message || '网络请求失败';
            // ElementUI.Message.error(errorMsg);
            console.log(errorMsg)
            return Promise.reject(error);
        }
    );

  import moment from 'moment'     //日期时间转换
  export default {
    name: "carList",
    components: {

    },
    props: {},
    data() {
      return {
          api: http,
          openCar:false,
          // 处理相关
          confidence: 0.4,
          processing: false,
          progress: 0,
          loadingText: '处理中，请稍候...',

          carStyleMenus:[],
        pitch_id:'',
        drawerHub:false,
        hubList:[],
        total1:0,
        pageNum1:1,
        pageSize1:20,

        formData:{},
        title:'',
        visible:false,
        // 搜索
        searchForm: {
            title: "",
          style_ids:[],
          style_id:'',
            year_id:''
        },
          carYearList:[],
        searchRules: {

          name: [
            { required: true, message: "请输入名称", trigger: "blur" }
          ],
        },
        // 数据
        tableLoadData: [],
        pageNum:1,// 当前页码
        pageSize:10,// 每页大小
        total:0,//总条目数

        showType: '',

        roleList: [],

        rules: {
          name: [
            { required: true, message: '请输入名称', trigger: 'blur' },
            {
              min: 3,
              max: 15,
              message: "长度在 3 到 15 个字符",
              trigger: "blur",
            }
          ],

        },

        dialogFormVisible: false,
        form: {
          name: '',
        },

      };
    },
    created() {
      this.DataList()
      this.getCarStyleMenus();
      this.getCarYeaList();
    },
    mounted() {
    },
    filters: {
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },


    },
    methods: {
        // 检测轮毂
        async detectWheels(item) {

            this.processing = true;
            this.progress = 30;
            this.loadingText = '正在检测轮毂...';

            try {
                const formData = new FormData();
                formData.append('car_url', item.file_url);
                // 添加置信度
                formData.append('conf', this.confidence.toString());

                this.progress = 60;
                const startTime = Date.now();

                // 调用API
                const response = await this.api.post('/api/detect', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                this.processingTime = Date.now() - startTime;
                this.detectionResult = response;
                this.progress = 90;

                console.log('检测结果response',response)
                if(response&&response.detections){
                    let param={
                        access_token:sessionStorage.getItem('token'),
                        company_id:sessionStorage.getItem('company_id'),
                        id:item.id,
                        detections:JSON.stringify(response.detections)
                    };

                    this.$axios.carinfoUpdateDetections(param).then(res=>{
                        if(res.code==200){
                            this.total=0;
                            this.tableLoadData=[];
                            this.pageNum=1;
                            this.DataList()
                        }
                        console.log(res)
                    });
                }
                // if (response.detection_image) {
                //     this.resultImage = response.detection_image;
                // }

                this.progress = 100;
                this.$message.success('轮毂检测完成!');

                setTimeout(() => {
                    this.processing = false;
                    this.progress = 0;
                }, 1000);

            } catch (error) {
                this.processing = false;
                this.progress = 0;
                console.error('检测轮毂失败:', error);
                this.$message.error('检测轮毂失败: ' + (error.response?.data?.error || error.message || '未知错误'));
            }
        },
        getCarStyleMenus(){
            let _this = this;
            let params={
                access_token:sessionStorage.getItem('token'),
                company_id:sessionStorage.getItem('company_id'),
            };
            this.$axios.findCarStyleTree(params).then((res)=>{
                if(res.code == 200) {
                    _this.carStyleMenus=res.data;
                }
            });
        },
        getCarYeaList(){
            let _this = this;
            let params={
                access_token:sessionStorage.getItem('token'),
                company_id:sessionStorage.getItem('company_id'),
            };
            this.$axios. findCarYearList(params).then((res)=>{
                if(res.code == 200) {
                    _this.carYearList=res.data;
                }
            });
        },
        getval() {
            let _this = this;
            const obj = this.$refs['cascaderCarStyle'].getCheckedNodes();
            console.log('obj',obj)
            if(obj.length>0){
                _this.searchForm.style_id = obj[0].data.id;
            }else{
                _this.searchForm.style_id="";
            }

        },
      relationHub(row){
        this.drawerHub=true;
        this.pitch_id=row.pitch_id;
        this.getHubList();
      },
      getHubList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          pageNum1:this.pageNum1,
          pageSize1: this.pageSize1,
          pitch_id:this.pitch_id
        }
        this.$axios.findHubListP(param).then(res=>{
          if(res.code == 200){
            //  console.log(res,1111);
            this.hubList = res.data.data
            this.total1 = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      closeForm(){
        this.title="";
        this.visible=false;
      },
      goEdit(row){
        this.$router.push({path:'/carForm',query:{id:row.id}})
        // this.title="编辑用户";
        // this.formData.realname=row.realname;
        // this.formData.nickname=row.nickname;
        // this.formData.user_id=row.user_id;
        // this.formData.user_name=row.user_name;
        // this.formData.parent_id=row.parent_id;
        // this.formData.parent_name=row.parent?row.parent.realname:'';
        // this.visible=true;
      },
      goAdd(){
        // this.$router.replace('/carForm')
        this.$router.push('/carForm')
      },
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      DataList(){
        const param = {
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }

        if(this.searchForm.name){
          param.keyword=this.searchForm.name;
        }
        console.log(this.searchForm.style_ids)
          if(this.searchForm.style_id){
              param.style_id=this.searchForm.style_id;
          }
          if(this.searchForm.year_id){
              param.year_id=this.searchForm.year_id;
          }
        this.$axios.findCarListP(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },
      handleSizeChange1(newSize) {
        this.pageSize1 = newSize
        this.getHubList()
      },
      // 分页跳转
      handleCurrentChange1(newPage) {
        this.pageNum1 = newPage
        this.getHubList()
      },
      departData(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.findTree(param).then(res=>{
          if(res.code == 200){
            this.rightslist = res.data.data
          }
        }).catch(error=>{
          console.log(error);
        })
      },

      // 新增
      addData() {
        // this.title = '新增'
        // this.form = {
        //   name: '',
        // }
        // this.dialogFormVisible = true
        this.$router.push('/newsForm')
      },
      handelEdit(index) {
        this.id = index.data.row.id
        this.title = '编辑'
        this.form = {
          name: this.name,
        }
        this.dialogFormVisible = true
        // this.form = {...row};
        // 或者
        this.form = JSON.parse(JSON.stringify(index.data.row))
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },

      searchSubmit() {
       this.total=0;
       this.pageNum=1;
       this.tableLoadData=[];

       this.DataList();
      },

      handelDel(e) {
        console.log(e);
        this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            operator_id: sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.data.row.id,
          }
          this.$axios.insuranceCorpDel(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
        this.teamDialog = false
      },


    },
  };
</script>
<style>

</style>
